"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledIconRemove = exports.StyledChild = void 0;

var _localization = require("@lt/localization");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pluralizeUtils = require("../../../utils/pluralizeUtils");

var _CounterPluralize = require("../../CounterPluralize");

var KidsList = function KidsList(_ref) {
  var kidsValue = _ref.kidsValue,
      onRemoveChildren = _ref.onRemoveChildren;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, kidsValue.map(function (item, index) {
    var key = "".concat(item, "-").concat(item + index);
    return /*#__PURE__*/_react["default"].createElement(StyledChild, {
      key: key
    }, /*#__PURE__*/_react["default"].createElement(StyledIconRemove, {
      as: "button",
      "data-index": index,
      onClick: onRemoveChildren
    }, /*#__PURE__*/_react["default"].createElement(_CounterPluralize.Style.IconPlus, null)), /*#__PURE__*/_react["default"].createElement(StyledKidsItem, null, t('touristsPicker.child'), ", \xA0", /*#__PURE__*/_react["default"].createElement("span", null, item === 0 ? t('touristsPicker.oneYear') : "".concat(item, " ").concat((0, _pluralizeUtils.pluralizeYears)(item)))));
  }));
};

var StyledWrapper = _styledComponents["default"].ul.withConfig({
  displayName: "KidsList__StyledWrapper",
  componentId: "sc-15lc41m-0"
})(["border-bottom:1px solid ", ";"], function (props) {
  return props.theme.colors.lightGrey;
});

var StyledChild = _styledComponents["default"].li.withConfig({
  displayName: "KidsList__StyledChild",
  componentId: "sc-15lc41m-1"
})(["height:50px;display:flex;align-items:center;border-top:1px solid ", ";"], function (props) {
  return props.theme.colors.lightGrey;
});

exports.StyledChild = StyledChild;

var StyledKidsItem = _styledComponents["default"].div.withConfig({
  displayName: "KidsList__StyledKidsItem",
  componentId: "sc-15lc41m-2"
})(["font-size:14px;color:", ";> span{color:", ";}"], function (props) {
  return props.theme.colors.blackLight;
}, function (props) {
  return props.theme.colors.blackBase;
});

var StyledIcon = _styledComponents["default"].span.withConfig({
  displayName: "KidsList__StyledIcon",
  componentId: "sc-15lc41m-3"
})(["height:16px;min-width:16px;display:inline-flex;justify-content:center;align-items:center;"]);

var StyledIconRemove = (0, _styledComponents["default"])(StyledIcon).withConfig({
  displayName: "KidsList__StyledIconRemove",
  componentId: "sc-15lc41m-4"
})(["background:none;border:0;cursor:pointer;margin:0 8px;", "{width:16px;transform:rotate(45deg);::after,::before{background-color:", ";}}"], _CounterPluralize.Style.IconPlus, function (props) {
  return props.theme.colors.greyLight;
});
exports.StyledIconRemove = StyledIconRemove;
var _default = KidsList;
exports["default"] = _default;